<template>
  <div class="index-box">
    <div class="index-title">认领二维码/短网址
      <router-link to="/tabs/renling" style="color:#66b1ff;font-size:14px;float:right;">认领二维码/短网址 (自己在游客转换时候的短链接)</router-link>
    </div>

    <div style="color:#f76a1a;font-size: 12px;background: #f5f5f5;padding:10px 10px; text-align: left;margin:20px 0 50px 0;font-size: 16px;display: ;" >认领短网址注意事项<br>
      <div style="font-size: 12px;color:#999;">
        1). 为防止恶意认领，需要购买访问包<br>
        2). 注册时间在三天之内 <br>
        3). 短网址此前属于游客链接 <br>
        4). 游客链接在30天之内转换 <br>
        5). 如有不清楚，详情咨询客服 <br>
      </div>
    </div>

    <div >
          <div style="margin-left:100px;margin-bottom:20px;">
             <el-upload
                    action=""
                    :http-request="upload_img"
                    :show-file-list="false"
                    accept=".png"
            >
              <span class="border-gray pad510 bg_blue radius-5 fs12">+上传二维码</span>
               <span class="fs12 ml10">png格式</span>
            </el-upload>
          </div>
    </div>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="urlForm" label-width="100px">
      <el-form-item label="短网址：" prop="url">
        <el-input v-model="ruleForm.url" clearable @clear="urlClear" @input="urlInput"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="btn-box" type="primary" @click="submitForm">确认认领</el-button>
      </el-form-item>

    </el-form>


  </div>

</template>

<script>
import QRCode from 'qrcodejs2';
import qrcodeParser from 'qrcode-parser'
export default {
  name: "Index",
  data() {
    const validateUrl = (rule, value, callback) => {
      const isUrl = this.$common.isUrl(value);
      if (value === '') {
        callback(new Error('请输入要认领的短网址'));
      }else if (!isUrl){
        callback(new Error('请输入正确的链接'));
      } else {
        callback();
      }
    };
    return {
      qrcode_img:'',
      ruleForm: {
        url: '',
      },
      rules: {
        url: [
          { validator: validateUrl, trigger: 'blur' }
        ],
      },
      shortId: 0,
      shortUrl: "123456789",
      isShowResult: false,
    }
  },
  mounted() {
  },
  methods: {
    submitForm() {
      this.$refs.urlForm.validate((valid) => {
        if (valid) {
          this.zh();
        }
      });
    },
    async zh() {
      const postData = {
        url: this.ruleForm.url,
      };
      const {ret,data} = await this.$api.shortUrl.renling(postData);
      if (ret === 1000){
        this.$message.success("认领成功");
        this.$router.push('/tabs/shortUrlList');
      }
    },
    urlClear() {
      this.shortId = "";
      this.shortUrl = "";
      this.isShowResult = false;
      this.$refs.qrCodeDiv.innerHTML = '';
    },
    urlInput(val) {
      if (val === ''){
        this.shortId = "";
        this.shortUrl = "";
        this.isShowResult = false;
        this.$refs.qrCodeDiv.innerHTML = '';
      }
    },
    upload_img(file){
      var $this=this;
      this.$common.Upload(file,function(img){
        console.log(img);
        $this.qrcode_img=img;
        $this.qrcode_parse();
        $this.$forceUpdate();
      });
    },
    qrcode_parse(){
      var $this=this;
      let img = this.qrcode_img;
      qrcodeParser(img).then(res =>{
        console.log(res)
        $this.ruleForm.url=res;
      })
    }

  },
}
</script>

<style scoped>
.index-box{
  width: 940px;
  height: auto;
  margin-left: 80px;
  padding: 30px 120px 30px 40px;
}
.index-box .index-title{
  width: 100%;
  height: 28px;
  font-size: 20px;
  margin-bottom: 40px;
}
.index-box .btn-box{
  width: 100%;
}

</style>
